export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const FILE_URL = process.env.REACT_APP_FILE_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const APP_COLORS = {
  darkBlue: "#032155",
  lightBlue: "#112f65",
  yellow: "#f0dc1b",
  white: "#fff",
  black: "#000",
};

export const EVENT_NAMES_ENUM = {
  NtumaEventNames: "NtumaEventNames",
  NtumaClientEventNames: "NtumaClientEventNames",
  NtumaAgentEventNames: "NtumaAgentEventNames",
  NtumaRiderEventNames: "NtumaRiderEventNames",
  //markets
  ADD_MARKET: "ADD_MARKET",
  UPDATE_MARKET: "UPDATE_MARKET",
  DELETE_MARKET: "DELETE_MARKET",

  //categories
  ADD_CATEGORY: "ADD_CATEGORY",
  UPDATE_CATEGORY: "UPDATE_CATEGORY",
  DELETE_CATEGORY: "DELETE_CATEGORY",

  //products
  ADD_PRODUCT: "ADD_PRODUCT",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  DELETE_PRODUCT: "DELETE_PRODUCT",

  //product prices
  ADD_PRODUCT_PRICE: "ADD_PRODUCT_PRICE",
  UPDATE_PRODUCT_PRICE: "UPDATE_PRODUCT_PRICE",
  DELETE_PRODUCT_PRICE: "DELETE_PRODUCT_PRICE",

  //delivery fees
  ADD_DELIVERY_FEES: "ADD_DELIVERY_FEES",
  UPDATE_DELIVERY_FEES: "UPDATE_DELIVERY_FEES",
  DELETE_DELIVERY_FEES: "DELETE_DELIVERY_FEES",

  //notifications
  ADD_NOTIFICATON: "ADD_NOTIFICATON",
  UPDATE_NOTIFICATON: "UPDATE_NOTIFICATON",
  DELETE_NOTIFICATON: "DELETE_NOTIFICATON",

  // =================
  //agents
  ADD_AGENT: "ADD_AGENT",
  UPDATE_AGENT: "UPDATE_AGENT",
  DELETE_AGENT: "DELETE_AGENT",

  //agents earning type
  ADD_AGENTS_EARNING_TYPE: "ADD_AGENTS_EARNING_TYPE",
  UPDATE_AGENTS_EARNING_TYPE: "UPDATE_AGENTS_EARNING_TYPE",
  DELETE_AGENTS_EARNING_TYPE: "DELETE_AGENTS_EARNING_TYPE",

  //agents market subscription
  ADD_AGENTS_MARKET_SUBSCRIPTION: "ADD_AGENTS_MARKET_SUBSCRIPTION",
  UPDATE_AGENTS_MARKET_SUBSCRIPTION: "UPDATE_AGENTS_MARKET_SUBSCRIPTION",
  DELETE_AGENTS_MARKET_SUBSCRIPTION: "DELETE_AGENTS_MARKET_SUBSCRIPTION",

  //agents wallet
  ADD_AGENTS_WALLET: "ADD_AGENTS_WALLET",
  UPDATE_AGENTS_WALLET: "UPDATE_AGENTS_WALLET",
  DELETE_AGENTS_WALLET: "DELETE_AGENTS_WALLET",

  //banners
  ADD_BANNERS: "ADD_BANNERS",
  UPDATE_BANNERS: "UPDATE_BANNERS",
  DELETE_BANNERS: "DELETE_BANNERS",

  //dishes
  ADD_DISHES: "ADD_DISHES",
  UPDATE_DISHES: "UPDATE_DISHES",
  DELETE_DISHES: "DELETE_DISHES",

  //dish PRODUCTS
  ADD_DISH_PRODUCTS: "ADD_DISH_PRODUCTS",
  UPDATE_DISH_PRODUCTS: "UPDATE_DISH_PRODUCTS",
  DELETE_DISH_PRODUCTS: "DELETE_DISH_PRODUCTS",

  //messages
  ADD_MESSAGE: "ADD_MESSAGE",
  UPDATE_MESSAGE: "UPDATE_MESSAGE",
  DELETE_MESSAGE: "DELETE_MESSAGE",

  //orders
  ADD_ORDER: "ADD_ORDER",
  UPDATE_ORDER: "UPDATE_ORDER",
  DELETE_ORDER: "DELETE_ORDER",

  //riders
  ADD_RIDER: "ADD_RIDER",
  UPDATE_RIDER: "UPDATE_RIDER",
  DELETE_RIDER: "DELETE_RIDER",

  //riders wallet
  ADD_RIDERS_WALLET: "ADD_RIDERS_WALLET",
  UPDATE_RIDERS_WALLET: "UPDATE_RIDERS_WALLET",
  DELETE_RIDERS_WALLET: "DELETE_RIDERS_WALLET",

  //suppliers payment details
  ADD_SUPPLIERS_PAYMENT_DETAILS: "ADD_SUPPLIERS_PAYMENT_DETAILS",
  UPDATE_SUPPLIERS_PAYMENT_DETAILS: "UPDATE_SUPPLIERS_PAYMENT_DETAILS",
  DELETE_SUPPLIERS_PAYMENT_DETAILS: "DELETE_SUPPLIERS_PAYMENT_DETAILS",

  //transactions
  ADD_TRANSACTION: "ADD_TRANSACTION",
  UPDATE_TRANSACTION: "UPDATE_TRANSACTION",
  DELETE_TRANSACTION: "DELETE_TRANSACTION",

  //transactions
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",

  //user's wallet
  ADD_WALLET: "ADD_WALLET",
  UPDATE_WALLET: "UPDATE_WALLET",
  DELETE_WALLET: "DELETE_WALLET",
};
